import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2990114c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2990114c')) {
      api.createRecord('2990114c', component.options)
    } else {
      api.reload('2990114c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2990114c&", function () {
      api.rerender('2990114c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/products/index.vue"
export default component.exports